<template>
	<div class="o-container o-container--thin">
		<preloader-view class="o-v-rhythm--small" />
	</div>
</template>

<script>
	import PreloaderView from '../views/PreloaderView.vue';
	import { buildLogoutUrl } from '../../api/oauthClient';

	export default {
		components: {
			PreloaderView
		},
		mounted() {
			this.$store.dispatch('user/LOGOUT').then(() => {
				if (window.OAuthConfig && window.OAuthConfig.enabled) {
					// OAuth logout clears the Cognito session cookie globally —
					// this prevents silent re-authentication after the user logs out.
					// The image-tag pixel hack (cognitoSignOutURIs) is no longer needed.
					window.location.href = buildLogoutUrl();
				} else {
					// Clear the Cognito session cookie globally so silent re-authentication
					// cannot occur after logout. The logout_uri must be registered as a valid
					// logout URL in the Cognito app client (window.CognitoClientIdPlayfootball).
					const hostedUiUrl = window.CognitoHostedInterfaceURL;
					const clientId = window.CognitoClientIdPlayfootball;

					if (hostedUiUrl && clientId) {
						const logoutUri = encodeURIComponent(window.location.origin + '/');
						window.location.href = `${hostedUiUrl}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
					} else {
						this.$router.push({
							name: 'login',
							params: {
								message: {
									type: 'success',
									value: 'You have been logged out of your Football Account.'
								}
							}
						});
					}
				}
			});
		}
	};
</script>
